import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fromCartProductModifiersArray'
})
export class FromCartProducModifiersArrayPipe implements PipeTransform {
  transform(collection: any[]): string {
    const selectedModifiers = [];

    collection.map(group => {
      group.modifiers.forEach(modifier => {
        if (modifier.selected) {
          selectedModifiers.push(modifier);
        }
      });
    });
    return selectedModifiers.map(x => '+ ' + x.modifierName.trim()).join(', ');
  }
}
